module.exports = __webpack_public_path__ + "img/charity-1.846705fb.png";